var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxWorkingWithOthers01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-working-with-others-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,14.37V6H13v7.67l5.8,7.73-1.6,1.2L12,15.67,6.8,22.6,5.2,21.4,11,13.67V6H9v8.37L2.76,21.65l-1.52-1.3L7,13.63V4H17v9.63l5.76,6.72-1.52,1.3ZM5.71,3.29l-3-3L1.29,1.71l3,3Zm17-1.58L21.29.29l-3,3,1.42,1.42ZM2,10H5V8H2Zm17,0h3V8H19Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxWorkingWithOthers01);
export default __webpack_public_path__ + "static/media/24px-working-with-others-01.004a50008849c5dcc2125b154f46c3f0.svg";
export { ForwardRef as ReactComponent };